// extracted by mini-css-extract-plugin
module.exports = {"clickableChip":"styles_clickableChip__12tM1","chip":"styles_chip__3r52V","visuallyHidden":"styles_visuallyHidden__2booF"};